import { dataISOLocal } from './precos'

export function sugerirPrevisaoEntrega(
  base: Date,
  prazoMedioDias: number | null,
  diaEntrega: number | null,
): string {
  const data = new Date(base)
  data.setDate(data.getDate() + (prazoMedioDias ?? 0))
  if (diaEntrega !== null) {
    while (data.getDay() !== diaEntrega) {
      data.setDate(data.getDate() + 1)
    }
  }
  return dataISOLocal(data)
}
